import Http from "http";

export default class HttpError extends Error {
  code: number;
  constructor(code: number, message?: string) {
    super(message ?? Http.STATUS_CODES[code]);
    this.code = code;
  }
}
